/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */

AddModel({
	Name: "HighSecBlindfold",
	Folder: "HighSec",
	TopLevel: true,
	Categories: ["Restraints", "Blindfolds"],
	AddPose: ["Blindfolds"],
	Layers: ToLayerMap([
		{ Name: "Blindfold", Layer: "Blindfold", Pri: 40,
			Invariant: true,
			InheritColor: "Blindfold",
		},
		{ Name: "BlindfoldStrap", Layer: "Blindfold", Pri: 40.1,
			Invariant: true,
			InheritColor: "Strap",
			TieToLayer: "Blindfold",
			NoOverride: true,
		},
		{ Name: "BlindfoldStrapHardware", Layer: "Blindfold", Pri: 40.2,
			Invariant: true,
			InheritColor: "StrapHardware",
			TieToLayer: "BlindfoldStrap",
			NoOverride: true,
		},
		{ Name: "BlindfoldHarnessUpper", Layer: "BlindfoldStraps", Pri: 40,
			Invariant: true,
			InheritColor: "Harness",
			HideWhenOverridden: true,
		},
		{ Name: "BlindfoldHarnessRivetsUpper", Layer: "BlindfoldStraps", Pri: 40.1,
			Invariant: true,
			InheritColor: "Rivets",
			NoOverride: true,
			TieToLayer: "BlindfoldHarnessUpper",
		},
		{ Name: "BlindfoldHarnessLowerL", Layer: "GagFlatStraps", Pri: 30,
			Invariant: true,
			InheritColor: "HarnessL",
			NoOverride: true,
		},
		{ Name: "BlindfoldHarnessLowerR", Layer: "GagFlatStraps", Pri: 30,
			Invariant: true,
			InheritColor: "HarnessR",
			NoOverride: true,
		},
		{ Name: "BlindfoldHarnessLowerRivetsL", Layer: "GagFlatStraps", Pri: 30.1,
			Invariant: true,
			InheritColor: "RivetsL",
			TieToLayer: "BlindfoldHarnessLowerL",
			NoOverride: true,
		},
		{ Name: "BlindfoldHarnessLowerRivetsR", Layer: "GagFlatStraps", Pri: 30.1,
			Invariant: true,
			InheritColor: "RivetsR",
			TieToLayer: "BlindfoldHarnessLowerR",
			NoOverride: true,
		},
	])
});


AddModel(GetModelRestraintVersion("HighSecBlindfold", true));


AddModel({
	Name: "HighSecCollar",
	Folder: "HighSec",
	TopLevel: true,
	Categories: ["Accessories", "Collars"],
	Layers: ToLayerMap([
		{ Name: "Collar", Layer: "NeckCorsetOver", Pri: -25,
			Invariant: true,
			InheritColor: "Band",
			MorphPoses: {UprightHogtie: "", SuspendedHogtie: "", Hogtie: "Hogtie"},
			DisplacementSprite: "HiSecStraps",
			DisplacementInvariant: true,
			DisplaceAmount: 50,
			DisplaceLayers: {NeckCorsetOverStraps: true},
		},
		{ Name: "CollarChest", Layer: "NeckCorsetOver", Pri: -25,
			Invariant: true,
			InheritColor: "Collar",
			MorphPoses: {Up: "Up", Boxtie: "Tied", Front: "Tied", Wristtie: "Tied", Crossed: "Tied",},
		},
		{ Name: "CollarChestRim", Layer: "NeckCorsetOver", Pri: -24.9,
			Invariant: true,
			NoOverride: true,
			InheritColor: "Rim",
			TieToLayer: "CollarChest",
			MorphPoses: {Up: "Up", Boxtie: "Tied", Front: "Tied", Wristtie: "Tied", Crossed: "Tied",},
		},
		{ Name: "CollarChestHardware", Layer: "NeckCorsetOver", Pri: -24.8,
			Invariant: true,
			NoOverride: true,
			InheritColor: "Ring",
			TieToLayer: "CollarChest",
		},
		{ Name: "CollarChestStraps", Layer: "NeckCorsetOver", Pri: -24.8,
			Invariant: true,
			NoOverride: true,
			InheritColor: "Straps",
			TieToLayer: "CollarChest",
			MorphPoses: {Up: "Up", Boxtie: "Tied", Front: "Tied", Wristtie: "Tied", Crossed: "Tied",},
		},
		{ Name: "CollarChestStrapsHardware", Layer: "NeckCorsetOver", Pri: -24.7,
			Invariant: true,
			NoOverride: true,
			InheritColor: "StrapsHardware",
			TieToLayer: "CollarChest",
			MorphPoses: {Up: "Up", Boxtie: "Tied", Front: "Tied", Wristtie: "Tied", Crossed: "Tied",},
		},
	])
});


AddModel(GetModelRestraintVersion("HighSecCollar", true));


AddModel({
	Name: "HighSecCorset",
	Folder: "HighSec",
	TopLevel: true,
	Categories: ["Corsets"],
	AddPose: ["Corset", "CrotchStrap", "HiSecGarter"],
	Layers: ToLayerMap([
		{ Name: "Corset", Layer: "OverCorset", Pri: 25,
			Invariant: true,
			InheritColor: "Corset",
			DisplaceAmount: 150,
			DisplaceLayers: ToMap(["CorsetTorso"]),
			DisplacementSprite: "CorsetSquish",
			DisplacementInvariant: true,
		},
		{ Name: "CorsetHardware", Layer: "OverCorset", Pri: 25.1,
			Invariant: true,
			InheritColor: "Hardware",
			NoOverride: true,
			TieToLayer: "Corset",
		},
		{ Name: "CorsetChest", Layer: "SuitChestOver", Pri: 25.1,
			Invariant: true,
			InheritColor: "Corset",
		},
		{ Name: "CorsetGarterLeft", Layer: "Garters", Pri: 24.9,
			Invariant: true,
			InheritColor: "GarterLeft",
			TieToLayer: "Corset",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetGarterLeftBack", Layer: "BehindTorso", Pri: -25,
			Invariant: true,
			InheritColor: "GarterLeft",
			//TieToLayer: "Corset",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			SwapLayerPose: {"HiSecGarterHeelLeft": "Garters"},
		},
		{ Name: "CorsetGarterRight", Layer: "Garters", Pri: 24.9,
			Invariant: true,
			InheritColor: "GarterRight",
			TieToLayer: "Corset",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetGarterRightBack", Layer: "BehindTorso", Pri: -25,
			Invariant: true,
			InheritColor: "GarterRight",
			//TieToLayer: "Corset",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			AppendPoseRequire: {"Spread": true, "Closed": true, "Hogtie": true},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
		},
		{ Name: "CorsetCrotchStraps", Layer: "OverCorset", Pri: 24.9,
			Invariant: true,
			InheritColor: "CrotchStraps",
			TieToLayer: "Corset",
			NoOverride: true,
		},




		{ Name: "CorsetHardwareGarterLeft", Layer: "Garters", Pri: 24.95,
			Invariant: true,
			InheritColor: "GarterLeftHardware",
			TieToLayer: "CorsetGarterLeft",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetHardwareGarterLeftBack", Layer: "BehindTorso", Pri: -24.95,
			Invariant: true,
			InheritColor: "GarterLeftHardware",
			TieToLayer: "CorsetGarterLeftBack",
			//TieToLayer: "Corset",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			SwapLayerPose: {"HiSecGarterHeelLeft": "Garters"},
		},
		{ Name: "CorsetHardwareGarterRight", Layer: "Garters", Pri: 24.95,
			Invariant: true,
			InheritColor: "GarterRightHardware",
			TieToLayer: "CorsetGarterRight",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetHardwareGarterRightBack", Layer: "BehindTorso", Pri: -24.95,
			Invariant: true,
			InheritColor: "GarterRightHardware",
			TieToLayer: "CorsetGarterRightBack",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			AppendPoseRequire: {"Spread": true, "Closed": true, "Hogtie": true},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
		},
		{ Name: "CorsetHardwareCrotchStraps", Layer: "OverCorset", Pri: 24.95,
			Invariant: true,
			InheritColor: "CrotchStrapsHardware",
			TieToLayer: "CorsetCrotchStraps",
			NoOverride: true,
		},
	])
});

AddModel(GetModelRestraintVersion("HighSecCorset", true));


AddModel({
	Name: "HighSecCorsetNoCrotch",
	Folder: "HighSec",
	TopLevel: true,
	Categories: ["Corsets"],
	AddPose: ["Corset", "HiSecGarter"],
	Layers: ToLayerMap([
		{ Name: "Corset", Layer: "OverCorset", Pri: 25,
			Invariant: true,
			InheritColor: "Corset",
			Sprite: "CorsetNoCrotch",
			DisplaceAmount: 150,
			DisplaceLayers: ToMap(["CorsetTorso"]),
			DisplacementSprite: "CorsetSquish",
			DisplacementInvariant: true,
		},
		{ Name: "CorsetHardware", Layer: "OverCorset", Pri: 25.1,
			Invariant: true,
			InheritColor: "Hardware",
			NoOverride: true,
			TieToLayer: "Corset",
		},
		{ Name: "CorsetChest", Layer: "SuitChestOver", Pri: 25.1,
			Invariant: true,
			InheritColor: "Corset",
		},
		{ Name: "CorsetGarterLeft", Layer: "Garters", Pri: 24.9,
			Invariant: true,
			InheritColor: "GarterLeft",
			TieToLayer: "Corset",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetGarterLeftBack", Layer: "BehindTorso", Pri: -25,
			Invariant: true,
			InheritColor: "GarterLeft",
			//TieToLayer: "Corset",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			SwapLayerPose: {"HiSecGarterHeelLeft": "Garters"},
		},
		{ Name: "CorsetGarterRight", Layer: "Garters", Pri: 24.9,
			Invariant: true,
			InheritColor: "GarterRight",
			TieToLayer: "Corset",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetGarterRightBack", Layer: "BehindTorso", Pri: -25,
			Invariant: true,
			InheritColor: "GarterRight",
			//TieToLayer: "Corset",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			AppendPoseRequire: {"Spread": true, "Closed": true, "Hogtie": true},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
		},




		{ Name: "CorsetHardwareGarterLeft", Layer: "Garters", Pri: 24.95,
			Invariant: true,
			InheritColor: "GarterLeftHardware",
			TieToLayer: "CorsetGarterLeft",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetHardwareGarterLeftBack", Layer: "BehindTorso", Pri: -24.95,
			Invariant: true,
			InheritColor: "GarterLeftHardware",
			TieToLayer: "CorsetGarterLeftBack",
			//TieToLayer: "Corset",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelLeft": "Garter"},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			SwapLayerPose: {"HiSecGarterHeelLeft": "Garters"},
		},
		{ Name: "CorsetHardwareGarterRight", Layer: "Garters", Pri: 24.95,
			Invariant: true,
			InheritColor: "GarterRightHardware",
			TieToLayer: "CorsetGarterRight",
			NoOverride: true,
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			//AppendPoseRequire: {"Kneel": true, "KneelClosed": true},
		},
		{ Name: "CorsetHardwareGarterRightBack", Layer: "BehindTorso", Pri: -24.95,
			Invariant: true,
			InheritColor: "GarterRightHardware",
			TieToLayer: "CorsetGarterRightBack",
			NoOverride: true,
			AppendPose: {"HiSecGarterHeelRight": "Garter"},
			AppendPoseRequire: {"Spread": true, "Closed": true, "Hogtie": true},
			MorphPoses: {Kneel: "Kneel", KneelClosed: "Kneel", Closed: "Closed", Hogtie: "Closed"},
		},
	])
});

AddModel(GetModelRestraintVersion("HighSecCorsetNoCrotch", true));


AddModel({
	Name: "HighSecLegbinder",
	Folder: "HighSecLegbinder",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Legbinder", "Leather"],
	Layers: ToLayerMap([
		{ Name: "Legbinder", Layer: "LegbinderLegsOver", Pri: -30,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			//HideWhenOverridden: true,
			InheritColor: "Binder",
			DisplaceAmount: 100,
			DisplaceLayers: ToMap(["Legbinder"]),
			DisplacementSprite: "LegbinderSquish",

		},
		{ Name: "LegLegbinder", Layer: "LegbinderAnklesOver", Pri: -30,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			SwapLayerPose: {Kneel: "LegbinderLegsOver", KneelClosed: "LegbinderLegsOver"},
			InheritColor: "Binder",
		},
		{ Name: "RightLegbinder", Layer: "LegbinderLegsOver", Pri: -30,
			//SwapLayerPose: {Kneel: "WrappingLegsRightOver", KneelClosed: "WrappingLegsRightOver"},
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			TieToLayer: "Legbinder",
			InheritColor: "Binder",

		},
		{ Name: "LegRightLegbinder", Layer: "LegbinderAnklesOver", Pri: -30,
			SwapLayerPose: {Kneel: "WrappingLegsRight", KneelClosed: "WrappingLegsRight"},
			Poses: ToMap(["Closed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			TieToLayer: "LegLegbinder",
			InheritColor: "Binder",

		},
		{ Name: "LacesTie", Layer: "LegbinderLegsOver", Pri: -24,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "LacesTie",
		},
		{ Name: "LacesLegbinder", Layer: "LegbinderLegsOver", Pri: -25,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Laces",
		},
		{ Name: "RightLacesLegbinder", Layer: "LegbinderLegsOver", Pri: -25,
			Poses: ToMap(["KneelClosed"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Laces",
		},
		{ Name: "LegLacesLegbinder", Layer: "LegbinderAnklesOver", Pri: -25,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Laces",
		},

		{ Name: "StrapsLegbinder", Layer: "LegbinderLegsOver", Pri: -24.5,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Straps",
		},
		{ Name: "RightStrapsLegbinder", Layer: "LegbinderLegsOver", Pri: -24.5,
			Poses: ToMap(["KneelClosed"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Straps",
		},
		{ Name: "LegStrapsLegbinder", Layer: "LegbinderAnklesOver", Pri: -24.5,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Straps",
		},

		{ Name: "StrapsHardwareLegbinder", Layer: "LegbinderLegsOver", Pri: -24.4,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Hardware",
		},
		{ Name: "RightStrapsHardwareLegbinder", Layer: "LegbinderLegsOver", Pri: -24.4,
			Poses: ToMap(["KneelClosed"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Hardware",
		},
		{ Name: "LegStrapsHardwareLegbinder", Layer: "LegbinderAnklesOver", Pri: -24.4,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Hardware",
		},
	])
});




AddModel({
	Name: "HighSecHobbleSkirt",
	Folder: "HighSecHobbleSkirt",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Legbinder", "Leather"],
	AddPose: ["EncaseTorsoLower"],
	Layers: ToLayerMap([
		{ Name: "Skirt", Layer: "WrappingTorsoLower", Pri: -40,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			InheritColor: "Skirt",
			Invariant: true,
			MorphPoses: {KneelClosed: "Kneel"},

		},
		/*{ Name: "SkirtStraps", Layer: "WrappingTorsoLower", Pri: -34.5,
			NoOverride: true,
			Invariant: true,
			TieToLayer: "Skirt",
			InheritColor: "Straps",
		},
		{ Name: "SkirtStrapsHardware", Layer: "WrappingTorsoLower", Pri: -34.4,
			NoOverride: true,
			Invariant: true,
			TieToLayer: "Skirt",
			InheritColor: "Hardware",
		},*/


		{ Name: "Legbinder", Layer: "LegbinderLegsOver2", Pri: -40,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			//HideWhenOverridden: true,
			InheritColor: "Skirt",
			DisplaceAmount: 100,
			DisplaceLayers: ToMap(["Legbinder"]),
			DisplacementSprite: "LegbinderSquish",

		},
		{ Name: "LegLegbinder", Layer: "LegbinderAnklesOver", Pri: 500-40,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			SwapLayerPose: {Kneel: "LegbinderLegsOver2", KneelClosed: "LegbinderLegsOver2"},
			InheritColor: "Skirt",
		},
		{ Name: "RightLegbinder", Layer: "LegbinderLegsOver2", Pri: -40,
			//SwapLayerPose: {Kneel: "WrappingLegsRightOver", KneelClosed: "WrappingLegsRightOver"},
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			TieToLayer: "Legbinder",
			InheritColor: "Skirt",

		},
		{ Name: "LegRightLegbinder", Layer: "LegbinderAnklesOver", Pri: 500-40,
			SwapLayerPose: {Kneel: "WrappingLegsRight", KneelClosed: "WrappingLegsRight"},
			Poses: ToMap(["Closed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			TieToLayer: "LegLegbinder",
			InheritColor: "Skirt",

		},

		/*
		{ Name: "StrapsLegbinder", Layer: "LegbinderLegsOver", Pri: -34.5,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Straps",
		},
		{ Name: "RightStrapsLegbinder", Layer: "LegbinderLegsOver", Pri: -34.5,
			Poses: ToMap(["KneelClosed"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Straps",
		},
		{ Name: "LegStrapsLegbinder", Layer: "LegbinderAnklesOver", Pri: -34.5,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Straps",
		},


		{ Name: "StrapsHardwareLegbinder", Layer: "LegbinderLegsOver", Pri: -34.4,
			Poses: ToMap(["Closed", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Hardware",
		},
		{ Name: "RightStrapsHardwareLegbinder", Layer: "LegbinderLegsOver", Pri: -34.4,
			Poses: ToMap(["KneelClosed"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Hardware",
		},
		{ Name: "LegStrapsHardwareLegbinder", Layer: "LegbinderAnklesOver", Pri: -34.4,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Legbinder",
			InheritColor: "Hardware",
		},*/
	])
});



AddModel({
	Name: "HighSecBalletHeels",
	Folder: "HighSecBallet",
	TopLevel: true,
	Restraint: false,
	Categories: ["Shoes"],
	AddPose: ["Heels", "FeetCovered", "HiSecGarterHeelLeft", "HiSecGarterHeelRight"],
	RemovePoses: ["TapeBoots"],
	Layers: ToLayerMap([
		{ Name: "TallLeft", Layer: "ShoeLeft", Pri: 30,
			AppendPose: {"HiSecGarter": "Garter"},
			NoAppendDisplacement: true,
			NoAppendErase: true,
			InheritColor: "ShoeLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap([...LEGPOSES]),
			SwapLayerPose: {Hogtie: "ShoeLeftHogtie"},
			DisplacementSprite: "Ballet",
			DisplaceAmount: 180,
			DisplaceLayers: ToMap(["Heels"]),
			DisplaceZBonus: 100,
			EraseInvariant: true,
			EraseMorph: {Spread: "Spread"},
			EraseSprite: "TallBalletErase",
			EraseAmount: 100,
			EraseLayers: ToMap(["Heels"]),
		},
		{ Name: "TallRight", Layer: "ShoeRight", Pri: 30,
			AppendPose: {"HiSecGarter": "Garter"},
			NoAppendDisplacement: true,
			NoAppendErase: true,
			InheritColor: "ShoeRight",
			Poses: ToMapSubtract([...LEGPOSES], ["Hogtie", "KneelClosed"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			SwapLayerPose: {Kneel: "ShoeRightKneel"},
			EraseInvariant: true,
			EraseMorph: {Closed: "Closed"},
			EraseSprite: "TallBalletRightErase",
			EraseAmount: 100,
			EraseLayers: ToMap(["HeelRight"]),
			EraseZBonus: 30000,
		},
		{ Name: "SoleLeft", Layer: "ShoeLeft", Pri: 30.1,
			InheritColor: "SoleLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap([...LEGPOSES]),
			SwapLayerPose: {Hogtie: "ShoeLeftHogtie"},
			TieToLayer: "TallLeft", NoOverride: true,

		},
		{ Name: "SoleRight", Layer: "ShoeRight", Pri: 30.1,
			InheritColor: "SoleRight",
			Poses: ToMapSubtract([...LEGPOSES], ["Hogtie", "KneelClosed"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			SwapLayerPose: {Kneel: "ShoeRightKneel"},
			TieToLayer: "TallRight", NoOverride: true,
		},
		{ Name: "TallLegLeft", Layer: "OverShoes", Pri: 31,
			AppendPose: {"HiSecGarter": "Garter"},
			InheritColor: "ShoeLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap(["Kneel", "KneelClosed", "Hogtie"]),
		},
		{ Name: "TallLegRight", Layer: "ShoeRightUnder", Pri: 31,
			AppendPose: {"HiSecGarter": "Garter"},
			InheritColor: "ShoeRight",
			Poses: ToMap(["Kneel", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
		},




		{ Name: "TallStrapsLeft", Layer: "ShoeLeft", Pri: 30.1,
			InheritColor: "StrapsLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap([...LEGPOSES]),
			SwapLayerPose: {Hogtie: "ShoeLeftHogtie"},

			Sprite: "TallLeft", Folder: "HighSecBalletStraps",
			TieToLayer: "TallLeft", NoOverride: true,

		},
		{ Name: "TallStrapsRight", Layer: "ShoeRight", Pri: 30.1,
			InheritColor: "StrapsRight",
			Poses: ToMapSubtract([...LEGPOSES], ["Hogtie", "KneelClosed"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			SwapLayerPose: {Kneel: "ShoeRightKneel"},

			Sprite: "TallRight", Folder: "HighSecBalletStraps",
			TieToLayer: "TallRight", NoOverride: true,
		},
		{ Name: "TallStrapsLegLeft", Layer: "OverShoes", Pri: 31.1,
			InheritColor: "StrapsLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap(["Kneel", "KneelClosed", "Hogtie"]),

			Sprite: "TallLegLeft", Folder: "HighSecBalletStraps",
			TieToLayer: "TallLegLeft", NoOverride: true,
		},
		{ Name: "TallStrapsLegRight", Layer: "ShoeRightUnder", Pri: 31.1,
			InheritColor: "StrapsRight",
			Poses: ToMap(["Kneel", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),

			Sprite: "TallLegRight", Folder: "HighSecBalletStraps",
			TieToLayer: "TallLegRight", NoOverride: true,
		},

		{ Name: "HardwareTallStrapsLeft", Layer: "ShoeLeft", Pri: 30.2,
			InheritColor: "HardwareLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap([...LEGPOSES]),
			SwapLayerPose: {Hogtie: "ShoeLeftHogtie"},

			Sprite: "HardwareTallLeft", Folder: "HighSecBalletStraps",
			TieToLayer: "TallLeft", NoOverride: true,

		},
		{ Name: "HardwareTallStrapsRight", Layer: "ShoeRight", Pri: 30.2,
			InheritColor: "HardwareRight",
			Poses: ToMapSubtract([...LEGPOSES], ["Hogtie", "KneelClosed"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			SwapLayerPose: {Kneel: "ShoeRightKneel"},

			Sprite: "HardwareTallRight", Folder: "HighSecBalletStraps",
			TieToLayer: "TallRight", NoOverride: true,
		},
		{ Name: "HardwareTallStrapsLegLeft", Layer: "OverShoes", Pri: 31.2,
			InheritColor: "HardwareLeft",
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			Poses: ToMap(["Kneel", "KneelClosed", "Hogtie"]),

			Sprite: "HardwareTallLegLeft", Folder: "HighSecBalletStraps",
			TieToLayer: "TallLegLeft", NoOverride: true,
		},
		{ Name: "HardwareTallStrapsLegRight", Layer: "ShoeRightUnder", Pri: 31.2,
			InheritColor: "HardwareRight",
			Poses: ToMap(["Kneel", "KneelClosed", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),

			Sprite: "HardwareTallLegRight", Folder: "HighSecBalletStraps",
			TieToLayer: "TallLegRight", NoOverride: true,
		},
	])
});


AddModel({
	Name: "HighSecBalletHeelsRestraint",
	Folder: "HighSecBallet",
	TopLevel: true,
	Restraint: true,
	Categories: ["Shoes"],
	AddPose: ["Heels", "RestrainingShoes", "FeetCovered", "HiSecGarterHeelLeft", "HiSecGarterHeelRight"],
	Layers: ToLayerMap([
		...GetModelLayers("HighSecBalletHeels"),
	])
});



AddModel({
	Name: "HighSecGloveLeft",
	Folder: "HighSecGloves",
	Parent: "HighSecGloves",
	Categories: ["Gloves"],
	Layers: ToLayerMap([
		{ Name: "GloveLeft", Layer: "GloveLeft", Pri: 8,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
		},
		{ Name: "ForeGloveLeft", Layer: "ForeGloveLeft", Pri: 8,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "GloveLeft",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveLeft"},
		},
		{ Name: "StrapsLeft", Layer: "GloveLeft", Pri: 8.1,
			Sprite: "GloveLeft", Folder: "HighSecGlovesStraps",
			InheritColor: "StrapsLeft",
			TieToLayer: "GloveLeft", NoOverride: true,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
		},
		{ Name: "ForeStrapsLeft", Layer: "ForeGloveLeft", Pri: 8.1,
			Sprite: "ForeGloveLeft", Folder: "HighSecGlovesStraps",
			InheritColor: "StrapsLeft",
			TieToLayer: "ForeGloveLeft", NoOverride: true,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveLeft"},
		},
	])
});

AddModel({
	Name: "HighSecGloveRight",
	Folder: "HighSecGloves",
	Parent: "HighSecGloves",
	Categories: ["Gloves"],
	Layers: ToLayerMap([
		{ Name: "GloveRight", Layer: "GloveRight", Pri: 8,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
		},
		{ Name: "ForeGloveRight", Layer: "ForeGloveRight", Pri: 8,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "GloveRight",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
		},

		{ Name: "StrapsRight", Layer: "GloveRight", Pri: 8.1,
			Sprite: "GloveRight", Folder: "HighSecGlovesStraps",
			InheritColor: "StrapsRight",
			TieToLayer: "GloveRight", NoOverride: true,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
		},
		{ Name: "ForeStrapsRight", Layer: "ForeGloveRight", Pri: 8.1,
			Sprite: "ForeGloveRight", Folder: "HighSecGlovesStraps",
			InheritColor: "StrapsRight",
			TieToLayer: "ForeGloveRight", NoOverride: true,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
		},
	])
});

AddModel({
	Name: "HighSecGloves",
	Folder: "HighSecGloves",
	Parent: "HighSecGloves",
	TopLevel: true,
	Categories: ["Gloves"],
	Layers: ToLayerMap([
		...GetModelLayers("HighSecGloveLeft"),
		...GetModelLayers("HighSecGloveRight"),
	])
});

AddModel(GetModelRestraintVersion("HighSecGloves", true));